import { createTheme } from "@mui/material";

const theme = createTheme({
	spacing: 8,
	shape: {
		borderRadius: 8,
	},
});

export default theme;
